"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _PostMessage = require("../api/PostMessage");
var _CoreProps = require("../utilities/CoreProps");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const Button = _ref => {
  let {
    children,
    className,
    color,
    primary,
    secondary,
    main,
    size,
    isHovered,
    isFocused,
    isActive,
    isText,
    isSelected,
    isStatic,
    responsive,
    loading,
    disabled,
    rounded,
    cornersRounded,
    outlined,
    inverted,
    fullWidth,
    onClick,
    handleClick,
    tooltip,
    dataTestId,
    renderAs,
    role,
    to,
    ...rest
  } = _ref;
  const onClickInternal = e => {
    if (typeof handleClick === 'function') {
      handleClick(e);
    } else if (typeof onClick === 'function') {
      onClick(e);
    }
    _PostMessage.PostMessage.postMessageCoreEvent('button-click', {
      className,
      disabled,
      tooltip,
      to
    });
  };
  let colorArg = color;
  if (secondary) {
    colorArg = 'secondary';
  }
  if (primary) {
    colorArg = 'primary';
  }
  if (className && (className.includes('is-primary') || className.includes('is-secondary'))) {
    colorArg = null;
  }
  const classNames = (0, _classnames.default)({
    [`is-${colorArg}`]: colorArg,
    [`is-${size}`]: size,
    'is-hovered': isHovered,
    'is-focused': isFocused,
    'is-active': isActive,
    'is-text': isText,
    'is-responsive': responsive,
    'is-selected': isSelected,
    'is-static': isStatic,
    'is-loading': loading,
    'is-rounded': rounded,
    'is-corners-rounded': cornersRounded,
    'is-outlined': outlined,
    'is-inverted': inverted,
    'is-fullwidth': fullWidth,
    'is-main': main
  });
  const RenderAs = isStatic ? 'span' : renderAs;
  return /*#__PURE__*/_react.default.createElement(RenderAs, _extends({
    className: (0, _classnames.default)('button', className, classNames) || undefined,
    onClick: onClickInternal,
    "data-tooltip": tooltip,
    disabled: disabled,
    "data-testid": dataTestId,
    to: to,
    role: role
  }, rest), children);
};
Button.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  primary: _propTypes.default.bool,
  main: _propTypes.default.bool,
  secondary: _propTypes.default.bool,
  color: _propTypes.default.oneOfType([_propTypes.default.oneOf(['primary', 'secondary', 'link', 'info', 'success', 'warning', 'danger', 'dark', 'text', 'white']), _propTypes.default.string]),
  size: _propTypes.default.oneOfType([_propTypes.default.oneOf(['small', 'medium', 'large']), _propTypes.default.string]),
  isHovered: _propTypes.default.bool,
  isFocused: _propTypes.default.bool,
  isActive: _propTypes.default.bool,
  isText: _propTypes.default.bool,
  isSelected: _propTypes.default.bool,
  isStatic: _propTypes.default.bool,
  responsive: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  rounded: _propTypes.default.bool,
  cornersRounded: _propTypes.default.bool,
  outlined: _propTypes.default.bool,
  inverted: _propTypes.default.bool,
  fullWidth: _propTypes.default.bool,
  handleClick: _propTypes.default.func,
  onClick: _propTypes.default.func,
  tooltip: _propTypes.default.string,
  role: _propTypes.default.string,
  dataTestId: _propTypes.default.string,
  renderAs: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object]),
  to: _propTypes.default.string
};
Button.defaultProps = {
  disabled: false,
  color: 'primary',
  tooltip: '',
  role: 'button',
  dataTestId: undefined,
  renderAs: 'button',
  to: undefined
};
var _default = exports.default = (0, _CoreProps.withUiProps)(Button);
//# sourceMappingURL=Button.js.map